import React, {useDeferredValue} from "react";
import {ReactComponent as HeroSvg} from "../../assets/img/Cases/cases_hero.svg";
import "./index.scss";
import {data} from "./data";
import {v4 as uuid} from "uuid";
import buttonClasses from "../../components/commons/Button.module.scss";
import {Link} from "react-router-dom";
import Container from "../../components/commons/Container";

const Cases = () => {
    const deferredData = useDeferredValue(data);
    return (
        <>
            <div className="col cases">
                <div className="content row jsb">
                    <Container className='cases_container'>
                        <div className="content_left  col flex jc">
                            <h1>Cases</h1>
                            <p>
                                Agilistry has helped up to 40 companies to develop from scratch
                                and implement their ideas into real projects, solve challenging
                                technical tasks and enhance performance and efficiency by
                                introducing manual and automated testing.
                            </p>
                        </div>
                        <div className="content_right  col flex center">
                            <HeroSvg/>
                        </div>
                    </Container>
                </div>
            </div>
            <div className="container">
                <div className="cases_wrapper">
                    {deferredData?.map((company) => (
                        <div className="cases_item" key={uuid()}>
                            <div className="cases_item_wrap col center">
                                <div className="cases_item_logo center">
                                    <img src={company.logo} alt=""/>
                                </div>
                                <div className="cases_item_text">{company.description} </div>
                            </div>
                            {company.link === "pdf" ? (
                                <a
                                    href={company.pfdUrl}
                                    // eslint-disable-next-line
                                    target="_blank"
                                    rel="noreferrer"
                                    className={`${buttonClasses.button} cases__button`}
                                    data-content={"read more"}
                                >
                                    read more
                                </a>
                            ) : (
                                <Link
                                    to={company.link}
                                    data-content={
                                        company.link === "#" ? "coming soon" : "read more"
                                    }
                                    className={`${buttonClasses.button} cases__button`}
                                >
                                    {company.link === "#" ? "coming soon" : "read more"}
                                </Link>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Cases;
